var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from '@web/utility';
var PrimaryButton = function (_a) {
    var onClick = _a.onClick, children = _a.children, _b = _a.type, type = _b === void 0 ? 'button' : _b, form = _a.form, className = _a.className, _c = _a.disabled, disabled = _c === void 0 ? false : _c;
    return (_jsx("button", __assign({ type: type, className: classNames('inline-flex  justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-50 text-sm font-medium text-indigo-700 md:leading-4 hover:bg-indigo-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500', disabled ? 'cursor-not-allowed' : 'cursor-pointer', className) }, {
        onClick: onClick,
        form: form,
        disabled: disabled
    }, { children: children })));
};
export default PrimaryButton;
